import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  // Comprueba si existe el token de autenticación en localStorage
  const isAuthenticated = localStorage.getItem('laravel_auth_token') ? true : false;
  
  // Si está autenticado, muestra los hijos (la página), si no, redirige al login
  return isAuthenticated ? children : <Navigate to="/login" replace />;
}